import { render, staticRenderFns } from "./DropableCell.vue?vue&type=template&id=0cb2f28f&"
import script from "./DropableCell.vue?vue&type=script&lang=ts&"
export * from "./DropableCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports